import {add} from '@acng/frontend-bounty/style/element.js';
import {all} from '@acng/frontend-bounty/dom/element.js';
import angular from 'angular';
import {connectPopupController} from '@acng/frontend-discovery';

angular.module('userPool')

  .directive('onswSignup', [() => {

    return {
      /**
       * @param {angular.IScope & {progress: boolean[], step: number}} scope
       */
      link: (scope, $element) => {
        const element = $element[0];

        add(element, 'ons-form');

        for (const label of all(element, 'label')) {
          connectPopupController(label);
        }

        scope.progress = [];
        scope.step = 1;

        scope.$watchGroup(['nickname', 'email', 'password'], function (values, old) {
          for (var i = 0; i < values.length; i++) {
            if (values[i] !== old[i]) {
              scope.progress[i] = true;
            }
          }
          scope.step = scope.progress.length + 1;
        });
      }
    };

  }]);
